module.exports = __webpack_public_path__ + "img/single-real-estate-listing.8e6084d1.png";